var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 7C6 6.44771 6.50368 6 7.125 6H13.875C14.4963 6 15 6.44771 15 7C15 7.55229 14.4963 8 13.875 8H7.125C6.50368 8 6 7.55229 6 7Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7474 15.6644C19.1143 15.2516 19.0772 14.6195 18.6644 14.2526C18.2516 13.8857 17.6195 13.9229 17.2526 14.3356L15.3333 16.4948L14.7474 15.8356C14.3805 15.4229 13.7484 15.3857 13.3356 15.7526C12.9229 16.1195 12.8857 16.7516 13.2526 17.1644L14.5859 18.6644C14.7757 18.8779 15.0477 19 15.3333 19C15.619 19 15.891 18.8779 16.0808 18.6644L18.7474 15.6644Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 4V10.8027C20.7934 11.8401 22 13.7792 22 16C22 19.3137 19.3137 22 16 22H4C2.89543 22 2 21.1046 2 20V4C2 2.89543 2.89543 2 4 2H17C18.1046 2 19 2.89543 19 4ZM4 4H17V10.083C16.6748 10.0284 16.3407 10 16 10C15.4906 10 14.9961 10.0635 14.5238 10.183C14.3405 10.0677 14.1166 10 13.875 10H7.125C6.50368 10 6 10.4477 6 11C6 11.5523 6.50368 12 7.125 12H11.5278C11.0113 12.5771 10.6048 13.2548 10.3414 14H7.125C6.50368 14 6 14.4477 6 15C6 15.5523 6.50368 16 7.125 16H10C10 17.5367 10.5777 18.9385 11.5278 20H4L4 4ZM16 20C18.2091 20 20 18.2091 20 16C20 13.7909 18.2091 12 16 12C13.7909 12 12 13.7909 12 16C12 18.2091 13.7909 20 16 20Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/request.7672ce87.svg";
export { ForwardRef as ReactComponent };